import { Empty, Table, Form, Input, message, Avatar } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import "./AllCard.css";
import {
  fCurrency,
  fCurrencyWithoutDecimal,
  fPercent,
  fPercentExact,
  fPercentWithoutSymbol,
} from "../../../helper/formatNumber";
import "./CustomTable.css";
import { getContestRanking, changeContestName } from "../../../api/contest";
import { useSelector } from "react-redux";
import { ActionIcons, AnnouncementModal, Button, Modal } from "@vt/vt-ui";
const locale = require("react-redux-i18n").I18n;

const CardRanking = ({ status, dataMe, dataWinner, fetchContestMe }) => {
  const user = useSelector((state) => state.user);

  const [data, setData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const limit = 5;
  const contestId = localStorage.getItem("contestId");

  const [form] = Form.useForm();
  const [isOpenChangeContestName, setIsOpenChangeContestName] = useState(false);
  const [contestName, setContestName] = useState("");
  const [inputLength, setInputLength] = useState(0);
  const [formError, setFormError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [showAnnouncementError, setShowAnnouncementError] = useState(false);

  const dataRankingMe = useMemo(() => {
    return dataMe?.data.map((e) => e)[0];
  }, [dataMe]);

  const fetchContestRanking = async (page = 1) => {
    try {
      const data = await getContestRanking({
        id: contestId,
        page: page,
        limit: limit,
      });
      setData(data.data);
      setTotal(data.data.total);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchContestRanking(currentPage);
  }, [currentPage]);

  useEffect(() => {
    if (isOpenChangeContestName) {
      setErrorMessage("");
      setFormError(false);
      const initialValue = contestName || dataMe?.data[0]?.username || "";
      form.setFieldsValue({
        contestName: initialValue,
      });
      setInputLength([...initialValue].length);
    }
  }, [isOpenChangeContestName, dataMe]);

  const columns = [
    {
      title: (
        <div className="d-flex justify-content-center">
          {locale.t("dashboardContest.rank")}
        </div>
      ),
      key: "rank",
      dataIndex: "rank",
    },
    {
      title: <div>{locale.t("dashboardContest.competitors")}</div>,
      key: "competitors",
      dataIndex: "competitors",
    },
    ...(dataWinner
      ? [
          {
            title: (
              <div className="d-flex justify-content-center">
                {locale.t("dashboardContest.prize")}($)
              </div>
            ),
            key: "prize",
            dataIndex: "prize",
          },
        ]
      : []),
    {
      title: (
        <div className="d-flex justify-content-end">
          {locale.t("dashboardContest.return_percent")}
        </div>
      ),
      key: "return",
      dataIndex: "return",
    },
  ];

  const renameContest = async () => {
    try {
      const values = form.getFieldsValue();
      if (!values.contestName || values.contestName.trim() === "") {
        setFormError(true);
        setErrorMessage("Please enter contest name");
      } else {
        try {
          const data = await changeContestName({
            id: dataMe.data[0].id,
            name: values.contestName,
          });

          if (data) {
            message.success(locale.t("contestNameSuccess"));
            setContestName(values.contestName);
            setIsOpenChangeContestName(false);
            setFormError(false);
            fetchContestRanking(currentPage);
            if (fetchContestMe) fetchContestMe();
          } else {
            setFormError(true);
            setErrorMessage("Cannot save contest name, please try again");
          }
        } catch (apiError) {
          if (
            apiError.response.data.code === 1102 ||
            apiError.response.data.code === 4000 ||
            apiError.response.data.code === 4001
          ) {
            setFormError(true);
            setErrorMessage(apiError.response.data.error);
          } else {
            setShowAnnouncementError(true);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const dataSource = useMemo(() => {
    return data?.data
      ?.sort((a, b) => a?.ranking - b?.ranking)
      .map((e) => {
        return {
          key: e?.id || `ranking-${e?.ranking}`,
          rank: (
            <div className="d-flex justify-content-center">
              {e?.ranking === 1 ||
              e?.ranking === 2 ||
              e?.ranking === 3 ||
              e?.ranking === 4 ||
              e?.ranking === 5 ? (
                e?.ranking === 1 ? (
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.9929 1.16429C9.23411 0.444285 10.7659 0.444285 12.0071 1.16429L14.325 2.50888L16.6484 3.84395C17.8925 4.55886 18.6584 5.88542 18.6555 7.32035L18.65 10L18.6555 12.6797C18.6584 14.1146 17.8925 15.4411 16.6484 16.1561L14.325 17.4911L12.0071 18.8357C10.7659 19.5557 9.23411 19.5557 7.9929 18.8357L5.675 17.4911L3.35161 16.1561C2.10745 15.4411 1.34156 14.1146 1.3445 12.6797L1.35 10L1.3445 7.32035C1.34156 5.88542 2.10745 4.55886 3.3516 3.84395L5.675 2.50888L7.9929 1.16429Z"
                      fill="#D2B554"
                    />
                    <g clip-path="url(#clip0_19776_6694)">
                      <path
                        d="M10 7.5L11.6667 10L13.75 8.33333L12.9167 12.5H7.08333L6.25 8.33333L8.33333 10L10 7.5Z"
                        fill="white"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_19776_6694">
                        <rect
                          width="10"
                          height="10"
                          fill="white"
                          transform="translate(5 5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                ) : e?.ranking === 2 ? (
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.32746 0.969537C9.3618 0.369529 10.6383 0.369529 11.6726 0.969537L14.325 2.50817L16.9838 4.03592C18.0205 4.63168 18.6588 5.73714 18.6563 6.93291L18.65 9.99929L18.6563 13.0657C18.6588 14.2614 18.0205 15.3669 16.9837 15.9627L14.325 17.4904L11.6726 19.029C10.6383 19.6291 9.3618 19.6291 8.32746 19.029L5.67505 17.4904L3.01634 15.9627C1.97955 15.3669 1.3413 14.2614 1.34376 13.0657L1.35005 9.99929L1.34376 6.93291C1.3413 5.73714 1.97955 4.63168 3.01634 4.03592L5.67505 2.50817L8.32746 0.969537Z"
                      fill="#A5A5A5"
                    />
                    <g clip-path="url(#clip0_19776_12019)">
                      <path
                        d="M10 7.5L11.6667 10L13.75 8.33333L12.9167 12.5H7.08333L6.25 8.33333L8.33333 10L10 7.5Z"
                        fill="white"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_19776_12019">
                        <rect
                          width="10"
                          height="10"
                          fill="white"
                          transform="translate(5 5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                ) : e?.ranking === 3 ? (
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.9929 1.16429C9.23411 0.444285 10.7659 0.444285 12.0071 1.16429L14.325 2.50888L16.6484 3.84395C17.8925 4.55886 18.6584 5.88542 18.6555 7.32035L18.65 10L18.6555 12.6797C18.6584 14.1146 17.8925 15.4411 16.6484 16.1561L14.325 17.4911L12.0071 18.8357C10.7659 19.5557 9.23411 19.5557 7.9929 18.8357L5.675 17.4911L3.35161 16.1561C2.10745 15.4411 1.34156 14.1146 1.3445 12.6797L1.35 10L1.3445 7.32035C1.34156 5.88542 2.10745 4.55886 3.3516 3.84395L5.675 2.50888L7.9929 1.16429Z"
                      fill="#C36D69"
                    />
                    <g clip-path="url(#clip0_19776_11831)">
                      <path
                        d="M10 7.5L11.6667 10L13.75 8.33333L12.9167 12.5H7.08333L6.25 8.33333L8.33333 10L10 7.5Z"
                        fill="white"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_19776_11831">
                        <rect
                          width="10"
                          height="10"
                          fill="white"
                          transform="translate(5 5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                ) : e?.ranking === 4 ? (
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.9929 1.16429C9.23411 0.444285 10.7659 0.444285 12.0071 1.16429L14.325 2.50888L16.6484 3.84395C17.8925 4.55886 18.6584 5.88542 18.6555 7.32035L18.65 10L18.6555 12.6797C18.6584 14.1146 17.8925 15.4411 16.6484 16.1561L14.325 17.4911L12.0071 18.8357C10.7659 19.5557 9.23411 19.5557 7.9929 18.8357L5.675 17.4911L3.35161 16.1561C2.10745 15.4411 1.34156 14.1146 1.3445 12.6797L1.35 10L1.3445 7.32035C1.34156 5.88542 2.10745 4.55886 3.3516 3.84395L5.675 2.50888L7.9929 1.16429Z"
                      fill="#009EFF"
                    />
                    <g clip-path="url(#clip0_19776_12072)">
                      <path
                        d="M10 7.5L11.6667 10L13.75 8.33333L12.9167 12.5H7.08333L6.25 8.33333L8.33333 10L10 7.5Z"
                        fill="white"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_19776_12072">
                        <rect
                          width="10"
                          height="10"
                          fill="white"
                          transform="translate(5 5)"
                        />
                      </clipPath>
                      ƒ
                    </defs>
                  </svg>
                ) : (
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.9929 1.16429C9.23411 0.444285 10.7659 0.444285 12.0071 1.16429L14.325 2.50888L16.6484 3.84395C17.8925 4.55886 18.6584 5.88542 18.6555 7.32035L18.65 10L18.6555 12.6797C18.6584 14.1146 17.8925 15.4411 16.6484 16.1561L14.325 17.4911L12.0071 18.8357C10.7659 19.5557 9.23411 19.5557 7.9929 18.8357L5.675 17.4911L3.35161 16.1561C2.10745 15.4411 1.34156 14.1146 1.3445 12.6797L1.35 10L1.3445 7.32035C1.34156 5.88542 2.10745 4.55886 3.3516 3.84395L5.675 2.50888L7.9929 1.16429Z"
                      fill="#009EFF"
                    />
                    <g clip-path="url(#clip0_19776_12026)">
                      <path
                        d="M10 7.5L11.6667 10L13.75 8.33333L12.9167 12.5H7.08333L6.25 8.33333L8.33333 10L10 7.5Z"
                        fill="white"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_19776_12026">
                        <rect
                          width="10"
                          height="10"
                          fill="white"
                          transform="translate(5 5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                )
              ) : (
                e?.ranking
              )}
            </div>
          ),
          competitors: (
            <div className="d-flex align-items-center" style={{ gap: "8px" }}>
              <Avatar
                style={{
                  backgroundColor: "#D2D2D2",
                  color: "#fff",
                  flex: "none",
                }}
                size={28}
              >
                <span style={{ fontSize: "14px", fontWeight: "700" }}>
                  {/^[a-zA-Z]$/.test(e.username?.charAt(0))
                    ? e.username?.charAt(0)
                    : "-"}
                </span>
              </Avatar>
              <span
                style={{
                  fontSize: "14px",
                  maxWidth: "150px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {e.username || "-"}
              </span>
            </div>
          ),
          prize: (
            <span
              className="d-flex justify-content-center"
              style={{ fontSize: "14px" }}
            >
              {dataWinner?.find((winner) => winner.ranking === e.ranking)
                ?.reward?.value
                ? `${fCurrencyWithoutDecimal(
                    dataWinner?.find((winner) => winner.ranking === e.ranking)
                      ?.reward?.value
                  )}`
                : "-"}
            </span>
          ),
          return: (
            <span
              className="d-flex justify-content-end"
              style={{ fontSize: "14px" }}
            >
              {fPercentWithoutSymbol(e.score)}
            </span>
          ),
        };
      });
  }, [data]);

  return (
    <div
      className="border d-flex p-24 flex-column box-ranking"
      style={{ borderRadius: "8px", gap: "16px", height: "487px" }}
    >
      <div className="text-bold text-ranking" style={{ fontSize: "16px" }}>
        {locale.t("dashboardContest.ranking")}
      </div>
      {status?.status === "upcoming" ||
      data?.data?.length <= 0 ||
      data?.data === undefined ? (
        <div
          style={{
            color: "#A3A3A3",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            flexDirection: "column",
          }}
        >
          <img
            src="/assets/images/icons/imageNotFound.png"
            style={{ width: "52px", height: "52px" }}
            alt=""
          />
          <div style={{ fontWeight: "800" }}>
            {locale.t("dashboardContest.title_no_ranking")}
          </div>
          <div style={{ fontSize: "12px" }}>
            {locale.t("dashboardContest.desc_no_ranking")}
          </div>
        </div>
      ) : (
        <>
          <div>
            <div className="d-flex align-items-center" style={{ gap: "14px" }}>
              <Avatar
                style={{
                  backgroundColor: "#D2D2D2",
                  color: "#fff",
                  flex: "none",
                }}
                size={78}
              >
                <span style={{ fontSize: "32px", fontWeight: "700" }}>
                  {/^[a-zA-Z]$/.test(dataMe?.data[0]?.username?.charAt(0))
                    ? dataMe?.data[0]?.username?.charAt(0).toUpperCase()
                    : "-"}
                </span>
              </Avatar>
              <div className="d-flex flex-column" style={{ gap: "8px" }}>
                <div
                  className="d-flex align-items-center"
                  style={{ gap: "6px" }}
                >
                  {locale.t("contestName")}:
                  <div
                    className="text-bold d-flex"
                    style={{ fontSize: "16px" }}
                  >
                    {dataMe?.data[0]?.username || "-"}{" "}
                    {dataMe?.data[0]?.username && (
                      <div style={{ fill: "#FFFFFF" }}>
                        <ActionIcons.PenLine
                          className="cursor-pointer !vt-fill-neutral-300"
                          size={16}
                          onClick={() => setIsOpenChangeContestName(true)}
                        />
                      </div>
                    )}
                    <AnnouncementModal
                      open={showAnnouncementError}
                      title="Invalid"
                      content="An error has occurred. Please try again later."
                      variant="error"
                      onSubmit={() => setShowAnnouncementError(false)}
                    />
                    <Modal
                      isOpen={isOpenChangeContestName}
                      onClose={() => setIsOpenChangeContestName(false)}
                      title="Change Contest Name"
                      size="md"
                      showCloseButton={true}
                    >
                      <Form form={form}>
                        <div>{locale.t("contestName")}</div>
                        <Form.Item
                          name="contestName"
                          validateStatus={formError ? "error" : ""}
                          help={formError ? errorMessage : ""}
                        >
                          <Input
                            className="ant-input-contest"
                            status={formError ? "error" : ""}
                            style={{ paddingTop: "0px", paddingBottom: "0px" }}
                            suffix={
                              <div style={{ color: "#A5A5A5" }}>
                                {16 - inputLength}
                              </div>
                            }
                            placeholder={locale.t("contestNamePlaceholder")}
                            onChange={(e) => {
                              const value = e.target.value.replace(/\s/g, "");
                              const valueArray = [...value];
                              if (valueArray.length <= 16) {
                                form.setFieldsValue({ contestName: value });
                                setInputLength(valueArray.length);
                              } else {
                                const trimmedValue = valueArray
                                  .slice(0, 16)
                                  .join("");
                                form.setFieldsValue({
                                  contestName: trimmedValue,
                                });
                                setInputLength(16);
                              }
                              setFormError(false);
                            }}
                          />
                        </Form.Item>
                        <Button
                          style={{ width: "100%", marginTop: "24px" }}
                          onClick={renameContest}
                        >
                          Confirm
                        </Button>
                      </Form>
                    </Modal>
                  </div>
                  <div
                    style={
                      !dataMe?.data.length > 0 ||
                      dataRankingMe?.status === "not_participate"
                        ? {
                            padding: "4px 8px",
                            borderRadius: "24px",
                            color: "#1E1E1E",
                            backgroundColor: "#D9D9D9",
                          }
                        : dataRankingMe?.status === "participate"
                        ? {
                            padding: "4px 8px",
                            borderRadius: "24px",
                            color: "#1CB894",
                            backgroundColor: "#F1FEFA",
                          }
                        : {
                            padding: "4px 8px",
                            borderRadius: "24px",
                            color: "#9D821F",
                            backgroundColor: "#FFF8D0",
                          }
                    }
                  >
                    {!dataMe?.data.length > 0 ||
                    dataRankingMe?.status === "not_participate"
                      ? locale.t("dashboardContest.not_participate")
                      : dataRankingMe?.status === "participate"
                      ? locale.t("dashboardContest.participate")
                      : locale.t("dashboardContest.preparing")}
                  </div>
                </div>
                <div>
                  {locale.t("dashboardContest.rank")}:{" "}
                  <span className="text-bold" style={{ fontSize: "14px" }}>
                    {dataRankingMe?.ranking ? dataRankingMe?.ranking : "-"}
                  </span>
                </div>
                <div>
                  {locale.t("dashboardContest.return")}:{" "}
                  <span className="text-bold" style={{ fontSize: "14px" }}>
                    {dataRankingMe?.score
                      ? fPercentExact(dataRankingMe?.score)
                      : "-"}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="contest">
            <Table
              locale={{
                emptyText: (
                  <Empty
                    description={"NoData"}
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  />
                ),
              }}
              columns={columns}
              dataSource={dataSource}
              style={{ fontSize: "12px" }}
              scroll={{ y: 200 }}
              pagination={{
                position: ["bottomCenter"],
                current: currentPage,
                total: total,
                pageSize: limit,
                onChange: (page) => {
                  setCurrentPage(page);
                },
                showSizeChanger: false,
                itemRender: (page, type, originalElement) => {
                  if (type === "page") {
                    const lastPage = Math.ceil(total / limit);
                    if (lastPage <= 5) {
                      return page;
                    }
                    if (
                      page === currentPage ||
                      page === currentPage + 1 ||
                      page === lastPage
                    ) {
                      return page;
                    }
                    return null;
                  }
                  return originalElement;
                },
                prevIcon: ({ disabled }) => (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M15.7071 5.29289C15.3166 4.90237 14.6834 4.90237 14.2929 5.29289L8.29289 11.2929C8.10536 11.4804 8 11.7348 8 12C8 12.2652 8.10536 12.5196 8.29289 12.7071L14.2929 18.7071C14.6834 19.0976 15.3166 19.0976 15.7071 18.7071C16.0976 18.3166 16.0976 17.6834 15.7071 17.2929L10.4142 12L15.7071 6.70711C16.0976 6.31658 16.0976 5.68342 15.7071 5.29289Z"
                      fill={disabled ? "#A3A3A3" : "#1E1E1E"}
                    />
                  </svg>
                ),
                nextIcon: ({ disabled }) => (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z"
                      fill={disabled ? "#A3A3A3" : "#1E1E1E"}
                    />
                  </svg>
                ),
              }}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default CardRanking;
